var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3 8.11032L14.62 10.7503C14.8 11.1103 15.28 11.4703 15.68 11.5303L18.07 11.9303C19.6 12.1903 19.96 13.2903 18.86 14.3903L17 16.2603C16.69 16.5703 16.51 17.1803 16.61 17.6203L17.14 19.9303C17.56 21.7503 16.59 22.4603 14.98 21.5103L12.74 20.1803C12.33 19.9403 11.67 19.9403 11.26 20.1803L9.00997 21.5003C7.39997 22.4503 6.42997 21.7403 6.84997 19.9203L7.37997 17.6103C7.47997 17.1803 7.29997 16.5703 6.98997 16.2503L5.13997 14.4003C4.03997 13.3003 4.39997 12.1903 5.92997 11.9403L8.31997 11.5403C8.71997 11.4703 9.19997 11.1203 9.37997 10.7603L10.7 8.12032C11.41 6.68032 12.59 6.68032 13.3 8.11032Z",
    fill: "#1C274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9.75C5.59 9.75 5.25 9.41 5.25 9V2C5.25 1.59 5.59 1.25 6 1.25C6.41 1.25 6.75 1.59 6.75 2V9C6.75 9.41 6.41 9.75 6 9.75Z",
    fill: "#1C274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9.75C17.59 9.75 17.25 9.41 17.25 9V2C17.25 1.59 17.59 1.25 18 1.25C18.41 1.25 18.75 1.59 18.75 2V9C18.75 9.41 18.41 9.75 18 9.75Z",
    fill: "#1C274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4.75C11.59 4.75 11.25 4.41 11.25 4V2C11.25 1.59 11.59 1.25 12 1.25C12.41 1.25 12.75 1.59 12.75 2V4C12.75 4.41 12.41 4.75 12 4.75Z",
    fill: "#1C274C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank);
export default __webpack_public_path__ + "static/media/rank.dcfac7507da98a1534e13e07b52b77dd.svg";
export { ForwardRef as ReactComponent };